<template>
  <div class="wrapper">
    <parallax class="page-header header-filter" :style="headerStyle">
      <div class="mask" />
      <div class="md-layout">
        <div class="md-layout-item">
          <div class="image-wrapper">
            <div class="slogan">
              <h1>把爱送回家</h1>
              <h4>
                YNBTECH代理了超过200款产自加拿大的高品质商品，并将其原装出口回国。
                <br />
                通过我们下单，我们将为您从国内库房直接发货，让您和您的家人轻松便捷地享用加拿大优质商品。
              </h4>
              <router-link :to="{name: 'products.wine'}">
                <md-button class="md-primary md-round">随便逛逛</md-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container">
          <div class="text-center">
            <h2>畅销产品</h2>
            <p>我们代理的冰酒、红酒、北极虾、海参、燕麦等产品广受市场的喜爱，好评如潮。</p>
          </div>
        </div>
      </div>
      <div class="section">
        <ProductCarousel :products="recommendList"/>
      </div>
      <div class="section call-to-action">
        <h1>加入我们，成为VIP</h1>
        <h4>无须充值，也没有最低限购，现在联系我们即可零门槛享受低至5折的VIP特价狂欢！</h4>
        <md-button class="md-white" @click="openChatbox">马上咨询</md-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BasicElements from "./components/BasicElementsSection";
import Navigation from "./components/NavigationSection";
import SmallNavigation from "./components/SmallNavigationSection";
import Tabs from "./components/TabsSection";
import NavPills from "./components/NavPillsSection";
import Notifications from "./components/NotificationsSection";
import TypographyImages from "./components/TypographyImagesSection";
import ProductCarousel from "@/components/products/ProductCarousel";

export default {
  components: {
    BasicElements,
    Navigation,
    SmallNavigation,
    Tabs,
    NavPills,
    Notifications,
    TypographyImages,
    ProductCarousel,
  },
  name: "index",
  bodyClass: "index-page",
  props: {
    image: {
      type: String,
      default: require("@/assets/img/bgs/ynbtrade-bg.jpg")
    },
    leaf4: {
      type: String,
      default: require("@/assets/img/leaf4.png")
    },
    leaf3: {
      type: String,
      default: require("@/assets/img/leaf3.png")
    },
    leaf2: {
      type: String,
      default: require("@/assets/img/leaf2.png")
    },
    leaf1: {
      type: String,
      default: require("@/assets/img/leaf1.png")
    },
    signup: {
      type: String,
      default: require("@/assets/img/city.jpg")
    },
    landing: {
      type: String,
      default: require("@/assets/img/landing.jpg")
    },
    profile: {
      type: String,
      default: require("@/assets/img/profile.jpg")
    }
  },
  data() {
    return {
      firstname: null,
      email: null,
      password: null,
      leafShow: false
    };
  },
  methods: {
    ...mapActions(['listProducts']),
    openChatbox() {
      if (window.tidioChatApi) {
        window.tidioChatApi.open();
      }
    },
    leafActive() {
      if (window.innerWidth < 768) {
        this.leafShow = false;
      } else {
        this.leafShow = false;
      }
    },
  },
  computed: {
    ...mapGetters(['products']),
    headerStyle() {
      return {
        backgroundImage: `url(${this.image})`
      };
    },
    signupImage() {
      return {
        backgroundImage: `url(${this.signup})`
      };
    },
    recommendList() {
      return this.products.filter(product => product.recommend === true);
    }
  },
  mounted() {
    this.leafActive();
    window.addEventListener("resize", this.leafActive);
    if (this.products.length === 0) {
      this.listProducts();
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.leafActive);
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/material-kit/_variables.scss";

.mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0.95) 0%, rgba(0, 0, 0, 0) 100%);
}

.slogan {
  text-align: center;
  color: $white;
  padding: 0 5%;

  h1 {
    margin-bottom: 1.5rem;
  }

  h4 {
    margin-bottom: 2rem;
  }
}

.section {
  padding: 1.5rem 0;
}

.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}

.section.steps {
  background: $gray-lighter;
}

.gallery {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-evenly;
  img {
    width: 20%;
  }
}

.section.call-to-action {
  background: url("../assets/img/bgs/orangeBG.jpg") center center no-repeat;
  background-size: cover;
  padding: 5rem 10%;
  color: white;
  background-attachment: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  border-radius: 0 0 5px 5px;

  /deep/ .md-button {
    margin-top: 2rem;
    .md-button-content {
      color: $gray-dark;
    }

    &:hover {
      .md-button-content {
        color: $orange;
      }

    }
  }
}
</style>
